module.exports = __webpack_public_path__ + "media/images/icon-calender-df372bcae7df0eae944825f1c5592090.svg";